import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from 'common/components/PageTitle';
import { Loader } from 'common/components/Loader';
import { BasePage } from 'hydra/pages/BasePage';

const ScormsManagementContent = lazy(() =>
    import('training/components/ScormsManagementContent').then((m) => ({
        default: m.ScormsManagementContent,
    }))
);

export const ScormsManagementPage = () => {
    const [translate] = useTranslation();

    return (
        <BasePage contentContainerMaxWidth="lg">
            <PageTitle>
                {translate('scormsManagementPage.browserTitle')}
            </PageTitle>

            <Suspense fallback={<Loader />}>
                <ScormsManagementContent />
            </Suspense>
        </BasePage>
    );
};
